export default __webpack_public_path__ + "static/media/aisthisi-4.df32c44c.gif";